// extracted by mini-css-extract-plugin
module.exports = {"main":"Narrow_main__ZsO5F"};